import * as universal from '../entries/pages/_layout.js';

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export { universal };
export const universal_id = "src/routes/+layout.js";
export const imports = ["_app/immutable/nodes/0.DJZQihiz.js","_app/immutable/chunks/scheduler.RgLb8lSQ.js","_app/immutable/chunks/index.RLhuoQOD.js","_app/immutable/chunks/stores.C131QKaH.js","_app/immutable/chunks/entry.Dk-gLehZ.js"];
export const stylesheets = ["_app/immutable/assets/fonts.Dg-7tPdz.css"];
export const fonts = [];
